export default "__VITE_ASSET__DDkEEB66__"